import './ckeditorTheme.css';

export default function Richtext({
  data,
}: {
  data: {
    content?: string;
  };
}) {
  if (data.content) {
    return (
      <div
        className="ck-content"
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
    );
  }
  return null;
}
